
import React, { Component } from 'react';
import { Modal, Transfer } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

class ProcurementPermissionTeam extends Component {

    state = {
        dataSource: [],
        targetKeys: [],
        userName:""
    }

    initData = (userName, callback) => {  
        //读取已设置的人员和可以设置的人员
        http.get({  
            url: '/procurement/permission/findUserAndMember',  //findMemberAndUser
            data: { userName: userName },
            success: (res) => {
                let all = [];
                let has = [];
                if (res.all != null && res.all.length > 0) {
                    for (let i = 0; i < res.all.length; i++) {
                        all.push({
                            key: res.all[i].memberCode,
                            title: res.all[i].memberName,
                            description: res.all[i].memberCode,
                        });
                    }
                    if (res.has != null && res.has.length > 0) {
                        for (let i = 0; i < res.has.length; i++) {
                            has.push(res.has[i].memberCode);
                        }
                    }
                }
                this.setState({
                    dataSource: all,
                    targetKeys: has,
                    userName:userName
                });
                if(callback){
                    callback(res);
                }
            }
        });
    }

    save = () => {
        let values = {};
        let userName = this.state.userName
        if (userName !== undefined && userName != null) {
            values["userName"] = userName;
        }
        values["memberCode"] = this.state.targetKeys.join(",");
        http.post({
            url: "/procurement/permission/updateMemberTeam",
            data: values,
            success: (res) => {
                this.props.successCallback(this.props.queryData);
                this.props.onCancel();
                messager.notify("保存成功！");
            }
        });
    };

    handleChange = (targetKeys, direction, moveKeys) => {
        this.setState({ targetKeys: targetKeys });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={540}
                visible={visible}
                title="商户人员配置"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ targetKeys: [] }) }}
            >
                <Transfer
                    dataSource={this.state.dataSource}
                    showSearch
                    locale={{ itemUnit: '人', itemsUnit: '人', searchPlaceholder: '用户名' }}
                    listStyle={{
                        width: 200,
                        height: 300,
                    }}
                    operations={['添加', '移除']}
                    targetKeys={this.state.targetKeys}
                    onChange={this.handleChange}
                    render={item => `${item.title}`}
                />

            </Modal>
        );
    }
}

export default ProcurementPermissionTeam;